import {api} from "../../config/api";
import secureStorage from "../../utils/secureStorage";

// Marketplace — matériel de caisse vendu par QuickCom.
// No backend endpoint yet: the catalogue is served from here. When the API
// exists, replace the body of fetchMarketplaceCatalog with an `api.get(...)`
// returning the same {categories, products} shape.

// Product photos live in public/marketplace/ (missing file → category icon)
const img = (file) => `${process.env.PUBLIC_URL || ""}/marketplace/${file}`;

export const MARKETPLACE_CATEGORIES = [
    {key: "pos", label: "Caisses tactiles"},
    {key: "printers", label: "Imprimantes ticket"},
    {key: "drawers", label: "Tiroirs-caisses"},
    {key: "scanners", label: "Lecteurs code-barres"},
    {key: "tablets", label: "Tablettes"},
    {key: "stands", label: "Supports tablette"},
    {key: "apple", label: "Accessoires Apple"},
    {key: "supplies", label: "Consommables"},
];

// Prix en DH TTC. discountPrice: prix remisé, null sans remise.
const PRODUCTS = [
    {
        id: "wd950-i5",
        image: img("wd950-i5.webp"),
        category: "pos",
        name: "Caisse tactile WD950 i5 — 15,6\"",
        description: "Terminal point de vente tout-en-un, écran tactile capacitif 15,6\", boîtier métal sans ventilateur, câbles dissimulés.",
        price: 4100,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Écran tactile capacitif 15,6\" (1366 × 768)", "Intel Core i5", "4 Go / 64 Go SSD ou 8 Go / 128 Go SSD", "6 × USB, COM, VGA, LAN", "Windows 10", "Options : 2ᵉ écran client, afficheur VFD, lecteur de carte, empreinte"],
    },
    {
        id: "wd920-i5",
        image: img("wd920-i5.webp"),
        category: "pos",
        name: "Caisse tactile WD920 i5 — 15,6\"",
        description: "Terminal tout-en-un 15,6\" en alliage d'aluminium, refroidissement passif et connectique cachée.",
        price: 5490,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Écran tactile capacitif 15,6\" (1366 × 768)", "Intel Core i5", "8 Go RAM · 128 Go SSD", "6 × USB, COM, VGA, LAN", "Windows 10", "Options : 2ᵉ écran client 11,6\", afficheur VFD"],
    },
    {
        id: "epson-tm-t20iii",
        image: img("epson-tm-t20iii.jpg"),
        category: "printers",
        name: "Imprimante ticket Epson TM-T20III (C31CH51012)",
        description: "Imprimante ticket thermique Epson, fiable et économique, avec réduction automatique du papier.",
        price: 1800,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Vitesse 250 mm/s", "USB + Ethernet", "Réduction automatique du papier", "Mécanisme 15 millions de lignes", "Commande du tiroir-caisse"],
    },
    {
        id: "wd8280",
        image: img("wd8280.webp"),
        category: "printers",
        name: "Imprimante ticket thermique WD8280",
        description: "Imprimante ticket 80 mm rapide (260 mm/s), étanche et anti-poussière, avec ouverture du tiroir-caisse.",
        price: 990,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Vitesse 260 mm/s", "Largeur d'impression 72 mm", "Coupe automatique", "USB, LAN, Bluetooth ou Wi-Fi selon modèle", "ESC/POS, Windows, Linux, Android, iOS", "Commande du tiroir-caisse"],
    },
    {
        id: "wd8260",
        image: img("wd8260.webp"),
        category: "printers",
        name: "Imprimante ticket thermique WD8260",
        description: "Imprimante ticket 80 mm (230 mm/s), coupe totale ou partielle, connexion au tiroir-caisse.",
        price: 890,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Vitesse 230 mm/s", "Largeur d'impression 80 mm", "Coupe totale ou partielle", "USB, LAN, Bluetooth, Wi-Fi ou RS232 selon modèle", "ESC/POS, Windows, Linux, Android, iOS", "Commande du tiroir-caisse"],
    },
    {
        id: "wd8270",
        image: img("wd8270.webp"),
        category: "printers",
        name: "Imprimante ticket thermique WD8270",
        description: "Imprimante ticket 80 mm (200 mm/s) USB + Ethernet, alarme fin de papier et protection surchauffe.",
        price: 790,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Vitesse 200 mm/s", "203 dpi, 576 points/ligne", "USB + Ethernet", "Alarme fin de papier", "Compatible Windows, Linux, macOS", "Commande du tiroir-caisse (RJ11 24 V)"],
    },
    {
        id: "wd0408",
        image: img("wd0408.webp"),
        category: "drawers",
        name: "Tiroir-caisse métallique WD0408",
        description: "Tiroir-caisse à ouverture automatique en métal, 4 billets / 8 pièces, s'ouvre via l'imprimante ticket.",
        price: 590,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["4 compartiments billets, 8 pièces, 1 fente chèques", "Serrure 3 positions", "Connexion RJ11 (12 V / 24 V)", "410 × 420 × 100 mm, 5,6 kg", "Coque acier, noir"],
    },
    {
        id: "inateck-bcst-35",
        image: img("inateck-bcst-35.webp"),
        category: "scanners",
        name: "Douchette sans fil Inateck BCST-35",
        description: "Lecteur code-barres 1D et 2D (QR codes) sans fil, à connecter en Bluetooth, 2,4 GHz ou USB.",
        price: 1000,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Codes 1D et 2D (QR code)", "Bluetooth, 2,4 GHz ou câble USB", "Compatible Windows, Android, iOS, macOS"],
    },
    {
        id: "inateck-wireless",
        image: img("inateck-wireless.webp"),
        category: "scanners",
        name: "Douchette sans fil Inateck 2,4 GHz",
        description: "Lecteur code-barres sans fil avec récepteur USB plug & play, lecture automatique et précise.",
        price: 1500,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Sans fil 2,4 GHz avec récepteur USB", "Utilisable aussi en filaire USB", "Plug & play, sans pilote"],
    },
    {
        id: "ipad-a16",
        image: img("ipad-a16.jpg"),
        category: "tablets",
        name: "iPad A16 (2025) 11\" — 128 Go",
        description: "Le dernier iPad d'entrée de gamme : écran 11\" et puce A16, parfait comme caisse QuickCom fixe ou mobile.",
        price: 6299,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Écran Liquid Retina 11\" bord à bord", "Puce Apple A16", "128 Go de stockage", "Caméras 12 Mpx avant (Center Stage) et arrière", "Wi-Fi 6, port USB-C, Touch ID", "4 coloris : bleu, rose, jaune, argent"],
    },
    {
        id: "ipad-9",
        image: img("ipad-9.jpg"),
        category: "tablets",
        name: "iPad 9ᵉ génération 10,2\" — 64 Go Wi-Fi",
        description: "iPad fiable et économique pour équiper une caisse QuickCom à petit prix.",
        price: 2600,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Écran Retina 10,2\"", "Puce Apple A13 Bionic", "64 Go de stockage", "Port Lightning", "Touch ID", "Wi-Fi"],
    },
    {
        id: "redmi-pad-2-pro-5g",
        image: img("redmi-pad-2-pro-5g.jpg"),
        category: "tablets",
        name: "Xiaomi Redmi Pad 2 Pro 5G — 8 Go / 256 Go",
        description: "Grande tablette Android 12,1\" avec 5G et très grosse batterie, pour une caisse QuickCom connectée partout.",
        price: 3990,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Écran 12,1\" 2,5K (2560 × 1600), 120 Hz", "Snapdragon 7s Gen 4", "8 Go RAM · 256 Go, extensible microSD", "Batterie 12 000 mAh, charge rapide 33 W", "5G + eSIM, Bluetooth 5.4"],
    },
    {
        id: "stand-universal",
        image: img("stand-universal.jpg"),
        category: "stands",
        name: "Support tablette universel",
        description: "Support de comptoir réglable pour poser la tablette de caisse face au vendeur ou au client.",
        price: 600,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Compatible tablettes iPad et Android", "Rotation et inclinaison réglables", "Base stable pour comptoir"],
    },
    {
        id: "stand-pos-printer",
        image: img("stand-pos-printer.jpg"),
        category: "stands",
        name: "Support iPad POS antivol avec espace imprimante",
        description: "Station de caisse métallique : la tablette est verrouillée par clé et l'imprimante ticket se range dans la base.",
        price: 1290,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Compatible iPad / Galaxy 9,7\" à 12,9\"", "Structure en métal", "Antivol avec clé et serrure", "Emplacement pour imprimante ticket", "Pour commerces et restaurants"],
    },
    {
        id: "stand-kiosk",
        image: img("stand-kiosk.jpg"),
        category: "stands",
        name: "Support kiosque antivol pivotant 360°",
        description: "Support métallique antivol pour iPad, hauteur réglable, pivote à 360° pour montrer l'écran au client.",
        price: 990,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Compatible tablettes 9,7\" à 13\"", "Rotation 360°", "Hauteur réglable 21 à 34 cm", "Acier / aluminium robuste", "Noir"],
    },
    {
        id: "apple-adapter-20w",
        image: img("apple-adapter-20w.jpg"),
        category: "apple",
        name: "Adaptateur secteur Apple USB-C 20 W (MD3J4ZM/A)",
        description: "Chargeur Apple d'origine pour iPad et iPhone, recharge rapide.",
        price: 249,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Produit Apple original, réf. MD3J4ZM/A", "Puissance 20 W", "Sortie USB-C", "Compatible iPad et iPhone"],
    },
    {
        id: "apple-cable-lightning-original",
        image: img("apple-cable-lightning-original.jpg"),
        category: "apple",
        name: "Câble Apple USB-C vers Lightning 1 m (MUQ93ZM/A)",
        description: "Câble Apple d'origine pour charger et synchroniser l'iPad 9ᵉ génération et les appareils Lightning.",
        price: 249,
        discountPrice: null,
        warranty: "1 an",
        inStock: true,
        features: ["Produit Apple original, réf. MUQ93ZM/A", "Longueur 1 m", "USB-C vers Lightning", "Charge rapide avec l'adaptateur 20 W"],
    },
    {
        id: "apple-cable-usbc-lightning",
        image: img("apple-cable-usbc-lightning.jpg"),
        category: "apple",
        name: "Câble D-Plus USB-C vers Lightning 20 W (1 m)",
        description: "Câble de charge rapide et de synchronisation pour iPad 9ᵉ génération et appareils Apple Lightning.",
        price: 149,
        discountPrice: null,
        warranty: "6 mois",
        inStock: true,
        features: ["Longueur 1 m", "USB-C vers Lightning", "Charge rapide 20 W", "Charge et synchronisation", "Compatible iPad 9ᵉ génération et iPhone Lightning"],
    },
    {
        id: "apple-cable-usbc",
        image: img("apple-cable-usbc.jpg"),
        category: "apple",
        name: "Câble USB-C vers USB-C (1 m)",
        description: "Pour charger l'iPad (A16) et les appareils USB-C.",
        price: 199,
        discountPrice: null,
        warranty: "6 mois",
        inStock: true,
        features: ["Longueur 1 m", "USB-C des deux côtés", "Compatible iPad (A16)"],
    },
    {
        id: "paper-80x80",
        image: img("paper-80x80.webp"),
        category: "supplies",
        name: "Rouleau papier thermique 80 × 80 mm",
        description: "Papier ticket thermique sans BPA pour imprimantes de caisse et TPE, sans encre ni toner.",
        price: 14,
        discountPrice: 12,
        warranty: null,
        inStock: true,
        features: ["80 mm × 80 mm", "Sans BPA", "Résiste à la chaleur, l'humidité et le frottement", "Compatible imprimantes POS et TPE"],
    },
    {
        id: "labels-100x100",
        image: img("labels-100x100.jpg"),
        category: "supplies",
        name: "Rouleau d'étiquettes thermiques 100 × 100 mm (500 étiquettes)",
        description: "Étiquettes autocollantes pour expédition, adresses de livraison et codes-barres.",
        price: 115,
        discountPrice: 69,
        warranty: null,
        inStock: true,
        features: ["100 mm × 100 mm", "500 étiquettes par rouleau", "Thermique direct, sans encre", "Résiste à l'eau, l'huile et les rayures", "Prédécoupées"],
    },
];

export const fetchMarketplaceCatalog = async () => ({
    categories: MARKETPLACE_CATEGORIES,
    products: PRODUCTS,
});

// Livraison: flat fee added to every order (the server applies the same amount).
export const DELIVERY_FEE = 40;

export const formatMoney = (value) =>
    `${(Number(value) || 0).toLocaleString("fr-FR", {minimumFractionDigits: 2, maximumFractionDigits: 2})} DH`;

// Price actually paid, and the discount in % when a remise applies.
export const effectivePrice = (product) =>
    hasDiscount(product) ? product.discountPrice : product.price;

export const hasDiscount = (product) =>
    product.discountPrice != null && Number(product.discountPrice) < Number(product.price);

export const discountPercent = (product) =>
    hasDiscount(product) ? Math.round((1 - product.discountPrice / product.price) * 100) : 0;

const headers = async () => {
    const account = await secureStorage.getItem("selectedAccount");
    return {"X-account-id": account?.id, Accept: "application/json"};
};

// Error message sent by the API ({error}), or a generic fallback.
export const apiErrorMessage = (error, fallback) =>
    error?.response?.data?.error || error?.response?.data?.detail || fallback;

// ── Commandes — clicoo MarketplaceOrderController (/api/marketplace/orders) ──

export const ORDER_STATUS_LABELS = {
    pending: "En attente",
    confirmed: "Confirmée",
    shipped: "Expédiée",
    delivered: "Livrée",
    cancelled: "Annulée",
};

export const ORDER_STATUS_CLASSES = {
    pending: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400",
    confirmed: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
    shipped: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400",
    delivered: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400",
    cancelled: "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300",
};

export const formatDateTime = (value) => {
    if (!value) return "—";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? value : date.toLocaleString("fr-FR", {dateStyle: "short", timeStyle: "short"});
};

// order: {id, contact_name, phone, address, note, items: [{product_id, name,
// quantity, unit_price, list_price}]}. `id` makes a retried submit idempotent.
export const placeMarketplaceOrder = async (order) => {
    const {data} = await api.post("/marketplace/orders", order, {headers: await headers()});
    return data;
};

// → {items, total, page, itemsPerPage}
export const fetchMarketplaceOrders = async ({status, page = 1, itemsPerPage = 20} = {}) => {
    const params = {page, itemsPerPage, ...(status ? {status} : {})};
    const {data} = await api.get("/marketplace/orders", {params, headers: await headers()});
    return data;
};

export const cancelMarketplaceOrder = async (id) => {
    const {data} = await api.post(`/marketplace/orders/${id}/cancel`, {}, {headers: await headers()});
    return data;
};
